import React from "react";
import Head from "next/head";
import { AuthProvider } from "../src/AuthContext";
import { BrandProvider } from "../src/BrandContext";
import { SocketStatusProvider } from "../src/SocketStatusContext";
import { OrderFilterProvider } from "../src/OrderFilterContext";
import { OrderProvider } from "../src/OrderContext";
import { DriverProvider } from "../src/DriverContext";
import { ChatProvider } from "../src/ChatContext";
import { SosProvider } from "../src/SosContext";
import { RoutesDirectionsProvider } from "../src/RoutesDirectionsContext";
import { ThemeProvider } from "../components/theme-provider";

import "../styles/globals.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import "react-datetime-picker/dist/DateTimePicker.css";

import "../styles/HeaderCard.css";
// Will move this after some time as module css
import "../styles/Compose.css";
import "../styles/ConversationList.css";
import "../styles/ConversationListItem.css";
import "../styles/Message.css";
import "../styles/MessageList.css";
import "../styles/Messenger.css";
import "../styles/Toolbar.css";
import "../styles/ToolbarButton.css";

import "../styles/PastTrips.css";

import "../styles/newOrder.css";
import "../styles/OrderDetailsNew.css";
import "../styles/NewHomePage.css";
import "../styles/stepper.css";
// import { ApolloProvider } from "@apollo/client/react";
import { ApolloProviderWrapper } from "../lib/apollo";

import { Toaster as SonnerToaster } from "../components/ui/sonner";
import NotificationHandler from "../components/NotificationHandler";

const App = ({ Component, pageProps }) => {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Dispatch Vert</title>
      </Head>
      <ApolloProviderWrapper>
        <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
          <AuthProvider>
            <BrandProvider>
            <SocketStatusProvider>
              <ChatProvider>
                <DriverProvider>
                  <OrderFilterProvider>
                    <RoutesDirectionsProvider>
                      <SosProvider>
                        <OrderProvider>
                          <NotificationHandler />
                          <Component {...pageProps} />
                        </OrderProvider>
                      </SosProvider>
                    </RoutesDirectionsProvider>
                  </OrderFilterProvider>
                </DriverProvider>
              </ChatProvider>
            </SocketStatusProvider>
            </BrandProvider>
          </AuthProvider>
        </ThemeProvider>
      </ApolloProviderWrapper>

      <SonnerToaster position="top-right" expand={true} richColors />
    </>
  );
};

export default App;
